import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import type { HttpErrorResponse } from '@angular/common/http';
import type { MobileSignInCheckData, MobileSignInStartData } from '../domain/mobile-sign-in';

@Injectable({
  providedIn: 'root'
})
export class MobileSignInQrCodeService {

  private securityTokenExpiry$ = new Subject<{ securityToken: string }>();

  get securityTokenExpired$() {
    return this.securityTokenExpiry$.asObservable();
  }

  constructor(
    private http: HttpClient
  ) { }

  createQrCode(options: {
    securityToken: string;
  }) {
    return this.securityPost<MobileSignInStartData>('/rest/qr/start', options.securityToken);
  }

  checkStatus(options: {
    id: number;
    securityToken: string;
  }) {
    return this.securityPost<MobileSignInCheckData>(`/rest/qr/${options.id}/status`, options.securityToken);
  }

  private securityPost<T>(
    url: string,
    securityToken: string,
    body?: object | null
  ) {
    return this.http.post<T>(
      url,
      {
        ...(body ? body : {}),
        security_token: securityToken
      },
      { responseType: 'json' }
    ).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403) {
          this.securityTokenExpiry$.next({ securityToken });
        }

        return throwError(error);
      })
    );
  }

}
